import makeStyles from '@mui/styles/makeStyles';
import { InputAdornment, TextField } from '@mui/material';
import { FC, useEffect, useState } from 'react';

interface IEditableCell {
  value: string;
  row: any;
  column: any;
  helperText?: string;
  hasError?: boolean;
  isNumberOnly?: boolean;
  updateMyData: (orginal: any, id: number, val: string, rowIndex: number) => void;
  disabled?: boolean;
  endAdornment?: string;
  label?: string;
}

export const EditableCell: FC<IEditableCell> = ({
  value: initialValue,
  row,
  column,
  hasError,
  helperText,
  isNumberOnly,
  disabled,
  updateMyData,
  endAdornment, // This is a custom function that we supplied to our table instance
  label
}) => {
  const classes = useStyles();
  // We need to keep and update the state of the cell normally
  const [value, setValue] = useState<string>(initialValue ?? '');
  const onChange = e => {
    if (isNumberOnly) {
      const re = /^-?[0-9\b]+$/;
      // make sure it is number only before we update state
      if (e.target.value === '' || re.test(e.target.value)) {
        setValue(e.target.value);
      }
    } else {
      setValue(e.target.value);
    }
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateMyData(row.original, column.id, value, row.index);
  };

  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(initialValue ?? '');
  }, [initialValue]);

  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      onBlur={onBlur}
      placeholder={column.Header}
      autoComplete="nope"
      value={value}
      label={label}
      required
      InputProps={{
        endAdornment: endAdornment ? (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ) : null
      }}
      classes={{
        root: classes.root
      }}
      disabled={disabled}
      onChange={onChange}
      error={hasError}
      helperText={helperText}
    />
  );
};

const useStyles = makeStyles(() => {
  return {
    root: {
      '&& .MuiFormHelperText-root': {
        position: 'absolute',
        bottom: '-20px'
      }
    }
  };
});
